import React, {useEffect, useState} from 'react';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {INDEX, RESULT, RESULT_DONE} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {updateQuiz, updateQuizVariables} from '../../shared/graphql/__generated__/updateQuiz';
import {UPDATE_QUIZ_MUTATION} from '../../shared/graphql/updateQuiz';

import {IQuestion, Question} from './Question';

import cls from './Quiz.module.scss'

const defalutAnswers:string[] = [
    '',
    '',
    '',
    '',
    '',
    '',
    ''
]


export const Quiz = observer( () => {

    const navigate = useNavigate()
    const [answers, setAnswers] = useState(defalutAnswers)
    const [updateQuiz] = useMutation<updateQuiz,updateQuizVariables>(UPDATE_QUIZ_MUTATION)

    const {auth} = useInstance(Store)

    useEffect(() => {
        if (!auth.auth) {
            navigate(INDEX)
        }
    }, [auth, navigate])

    const onSelect = async (index: number, value: string) => {

        let newAnswers = [...answers]
        newAnswers[index] = value
        await setAnswers(newAnswers)

        await updateQuiz({
            variables: {
                id: auth.id!,
                data: {
                    q_one: newAnswers[0],
                    q_two: newAnswers[1],
                    q_three: newAnswers[2],
                    q_four: newAnswers[3],
                    q_five: newAnswers[4],
                    q_six: newAnswers[5],
                    q_seven: newAnswers[6],
                }
            },
            onCompleted: (data) => {
                auth.setResult(data.updateQuiz?.data?.attributes?.result!)
                if (data.updateQuiz?.data?.attributes?.result! > 0 && data.updateQuiz?.data?.attributes?.result! < 7) {
                    auth.setAuth(false)
                    navigate(RESULT)
                }
                if (data.updateQuiz?.data?.attributes?.result! > 0 && data.updateQuiz?.data?.attributes?.result! === 7) {
                    auth.clearState()
                    navigate(RESULT_DONE)
                }

            }
        })

    }

    const quiz: IQuestion[] = [
        {
            number: '1',
            question: 'Сколько лет исполняется нашей компании в этом году?',
            answers: [
                {
                    value: '5',
                    label: '5',
                    selected: answers[0] === '5',
                },
                {
                    value: '19',
                    label: '19',
                    selected: answers[0] === '19',
                },
                {
                    value: '13',
                    label: '13',
                    selected: answers[0] === '13',
                },
            ],
            onSelect: (value) => onSelect(0, value)
        },
        {
            number: '2',
            question: 'Какое количество Airbus A320 вместится для работ по ПТО во все 3 ангарах S7 Technics: в Москве, Новосибирске и Минеральных Водах?',
            answers: [
                {
                    value: '17',
                    label: '17',
                    selected: answers[1] === '17',
                },
                {
                    value: '18',
                    label: '18',
                    selected: answers[1] === '18',
                },
                {
                    value: '19',
                    label: '19',
                    selected: answers[1] === '19',
                },
            ],
            onSelect: (value) => onSelect(1, value)
        },
        {
            number: '3',
            question: 'Какую глубину ремонта двигателей CFM56-5B и 7B мы освоили?',
            answers: [
                {
                    value: 'knd',
                    label: 'Капитальный ремонт модуля КНД',
                    selected: answers[2] === 'knd',
                },
                {
                    value: 'tnd',
                    label: 'Капитальный ремонт модуля ТНД',
                    selected: answers[2] === 'tnd',
                },
                {
                    value: 'kvd-tvd',
                    label: 'Капитальный ремонт статора КВД и ТВД',
                    selected: answers[2] === 'kvd-tvd',
                },
                {
                    value: 'knd-tnd-turbo',
                    label: 'Капитальный ремонт модулей КНД, ТНД, газогенератора',
                    selected: answers[2] === 'knd-tnd-turbo',
                },
            ],
            vertical: true,
            onSelect: (value) => onSelect(2, value)
        },
        {
            number: '4',
            question: 'Какая из площадок S7 Technics является наиболее «молодой» по услугам ПТО?',
            answers: [
                {
                    value: 'dme',
                    label: 'DME',
                    selected: answers[3] === 'dme',
                },
                {
                    value: 'ovb',
                    label: 'OVB',
                    selected: answers[3] === 'ovb',
                },
                {
                    value: 'mrv',
                    label: 'MRV',
                    selected: answers[3] === 'mrv',
                },
            ],
            onSelect: (value) => onSelect(3, value)
        },
        {
            number: '5',
            question: 'Правда ли, что S7 Technics ежегодно выполняет более 80 форм, эквивалентных C‑check?',
            answers: [
                {
                    value: 'yes',
                    label: 'Да',
                    selected: answers[4] === 'yes',
                },
                {
                    value: 'no',
                    label: 'Нет',
                    selected: answers[4] === 'no',
                },
            ],
            onSelect: (value) => onSelect(4, value)
        },
        {
            number: '6',
            question: 'В каком году S7 Technics начал выполнять полную покраску ВС?',
            answers: [
                {
                    value: '2011',
                    label: '2011',
                    selected: answers[5] === '2011',
                },
                {
                    value: '2014',
                    label: '2014',
                    selected: answers[5] === '2014',
                },
                {
                    value: '2018',
                    label: '2018',
                    selected: answers[5] === '2018',
                },
            ],
            onSelect: (value) => onSelect(5, value)
        },
        {
            number: '7',
            question: 'Сколько партийных номеров компонентов обслуживает S7 Technics?',
            answers: [
                {
                    value: '3000',
                    label: 'Менее 3000',
                    selected: answers[6] === '3000',
                },
                {
                    value: '4000',
                    label: '4000',
                    selected: answers[6] === '4000',
                },
                {
                    value: '5000',
                    label: 'Более 5000',
                    selected: answers[6] === '5000',
                },
            ],
            onSelect: (value) => onSelect(6, value)
        },

    ]

    return (

        <div className={cls.page}>

            {_.map(quiz, (question, index) => (
                <React.Fragment key={question.number}>
                    <Question number={question.number} question={question.question} answers={question.answers}
                              onSelect={question.onSelect} vertical={question.vertical}/>
                    {index !== (quiz.length - 1) && <div className={cls.divider}/>}
                </React.Fragment>
            ))}

        </div>

    )
})